const DEFAULT_ADMIN_EMAIL = "creativeflarebradford@yahoo.co.uk";

function isFormSubmitSuccess(body) {
  if (!body || body.success === undefined) return true;
  return body.success === true || body.success === "true";
}

async function formSubmit(to, payload) {
  const fields = {
    _template: "box",
    _captcha: "false",
    ...payload,
  };
  const body = new URLSearchParams();
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      body.append(key, String(value));
    }
  });

  const response = await fetch(`https://formsubmit.co/ajax/${encodeURIComponent(to)}`, {
    method: "POST",
    headers: { Accept: "application/json" },
    body,
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok || !isFormSubmitSuccess(result)) {
    throw new Error(result.message || "Could not send email");
  }
  return result;
}

export async function sendContactEmails({ name, email, subject, message, adminEmail }) {
  const to = adminEmail || DEFAULT_ADMIN_EMAIL;
  const first = (name || "").split(" ")[0] || name || "there";

  // FormSubmit _autoresponse does not work with AJAX. CC the visitor instead
  // so they receive a copy of the enquiry that landed in the admin inbox.
  return formSubmit(to, {
    name,
    email,
    subject,
    message,
    _replyto: email,
    _cc: email,
    _subject: `New website enquiry: ${subject || "General enquiry"}`,
    confirmation:
      `Hi ${first}, this is a copy of the message Creative Flare Yorkshire received. We will get back to you within two working days.`,
  });
}

/** Email the visitor a chat reply and leave a replyable copy in the admin inbox. */
export async function sendContactReplyEmails({
  visitorName,
  visitorEmail,
  subject,
  replyBody,
  senderName,
  adminEmail,
}) {
  if (!visitorEmail) throw new Error("Visitor email is missing");

  const toAdmin = adminEmail || DEFAULT_ADMIN_EMAIL;
  const first = (visitorName || "").split(" ")[0] || visitorName || "there";
  const topic = subject || "your enquiry";
  const fromName = senderName || "Creative Flare Yorkshire";
  const visitorMessage =
    `Hi ${first},\n\n` +
    `${fromName} replied to your message (${topic}):\n\n` +
    `${replyBody}\n\n` +
    `You can reply to this email to continue the conversation.\n\n` +
    `— Creative Flare Yorkshire C.I.C.`;

  // 1) Post to the already-confirmed admin FormSubmit inbox and CC the visitor.
  //    This is the reliable delivery path: _autoresponse is ignored on AJAX.
  await formSubmit(toAdmin, {
    name: fromName,
    email: toAdmin,
    visitor_name: visitorName,
    visitor_email: visitorEmail,
    _replyto: toAdmin,
    _cc: visitorEmail,
    _subject: `Re: ${topic} — Creative Flare Yorkshire`,
    message: visitorMessage,
  });

  // 2) Also send with the visitor as the To address (Reply-To = admin).
  //    First-time FormSubmit destinations may only get an activation email.
  try {
    await formSubmit(visitorEmail, {
      name: fromName,
      email: toAdmin,
      _replyto: toAdmin,
      _subject: `Re: ${topic} — Creative Flare Yorkshire`,
      message: visitorMessage,
    });
  } catch (err) {
    console.warn("Direct visitor FormSubmit send failed:", err.message);
  }

  // 3) Admin copy whose Reply-To is the visitor, so inbox Reply works.
  try {
    await formSubmit(toAdmin, {
      name: visitorName,
      email: visitorEmail,
      _replyto: visitorEmail,
      _subject: `Copy: reply sent to ${visitorName} (${topic})`,
      message:
        `You replied to ${visitorName} <${visitorEmail}> from the admin platform.\n\n` +
        `Reply:\n${replyBody}\n\n` +
        `Reply to this email to continue the conversation with them.`,
    });
  } catch (err) {
    console.warn("Admin copy email failed:", err.message);
  }
}
